import React, { Component } from 'react';
import IconButton from '../Buttons/IconButton/IconButton';
import LauncherPrompt from '../LauncherPrompt/LauncherPrompt';
import { TString } from '../Response/Utils';
import BotIcon4 from '../../../../assets/imgs/bot.svg';
import botLogo from '../../../../assets/imgs/shopify-bot.png';
import {
	InternationalizationContext,
	truthyOrFalsy,
} from '../../../../src/Utils/Contexts';
import { DefaultLogo } from '../../../../assets/imgs/Bot';

interface Props {
	isBotVisible: boolean;
	logoImagePath: string;
	returnSaneURL: Function;
	showBot: Function;
	data: any;
	isChatInputDisabled: boolean;
	isConnectedToNetwork: boolean;
	langCode?: string;
	launcherPromptBackground?: string;
	launcherPromptColor?: string;
	isChatStarted: boolean;
	launcherPromptMessage: string;
}
interface State {
	showMsg: boolean;
	size: number;
	height: number;
	width: number;
	// left: any;
	// top: any;
	right: any;
	bottom: any;
	showPrompt: boolean;
}
class Icon extends Component<Props, State> {
	constructor(props) {
		super(props);
		this.state = {
			showMsg: true,
			size: this.props.data.toasterEnabled ? 180 : 55,
			height: 0,
			width: 0,
			// left: 'calc(100% - 90px)',
			// top: 'calc(100% - 90px)'
			right: '0px',
			bottom: '0px',
			showPrompt: true,
		};
	}

	componentDidMount() {
		//Add this based on configs
		this.makeBotIconDraggable();
		if (
			this.props.data.flyFishChangesReq &&
			(this.props.data.isInsideCampaign || this.props.data.isInsideKampsta)
		) {
			this.props.showBot();
			this.closePrompt();
		}
	}
	componentDidUpdate(prevProps: any) {
		if (prevProps.isBotVisible === true && this.props.isBotVisible === false) {
			var draggedElemsID = 'sf-bot-icon';
			var draggedElem = document.getElementById(draggedElemsID);
			// draggedElem.style.left = this.state.left !== 0 ? this.state.left : 'unset';
			// draggedElem.style.top = this.state.top !== 0 ? this.state.top : 'unset';
			draggedElem.style.right =
				this.state.right !== 0 ? this.state.right : 'unset';
			draggedElem.style.bottom =
				this.state.bottom !== 0 ? this.state.bottom : 'unset';
		}
		if (!this.props.isBotVisible) {
			window.addEventListener('resize', () => this.handleResize());
		} else {
			window.removeEventListener('resize', () => this.handleResize());
		}
	}

	handleResize = () => {
		var draggedElemsID = 'sf-bot-icon';
		var draggedElem = document.getElementById(draggedElemsID);
		draggedElem && draggedElem.removeAttribute('style');
	};

	handleOnDragStart(ev) {
		ev.dataTransfer.effectAllowed = 'move';
		ev.dataTransfer.setData('text/plain', ev.target.id);
	}

	handleDrag(ev) {
		ev.dataTransfer.effectAllowed = 'move';
	}

	makeBotIconDraggable() {
		let body = document.body;
		body.addEventListener('dragover', (ev) => {
			if (ev.preventDefault) {
				ev.preventDefault(); // Necessary. Allows us to drop.
			}
			ev.dataTransfer.dropEffect = 'move';
			return false;
		});

		body.addEventListener('drop', (ev) => {
			var draggedElemsID = ev.dataTransfer.getData('text/plain');

			if (draggedElemsID !== 'sf-bot-icon') {
				return;
			} else {
				ev.preventDefault();
				var draggedElem = document.getElementById(draggedElemsID);

				let cordinates = {
					x: ev.clientX,
					y: ev.clientY,
				};

				let sizeX = cordinates.x - this.state.size; // + 'px';
				let sizeY = cordinates.y - this.state.size; // + 'px';
				// draggedElem.style.left = sizeX;
				// draggedElem.style.top = sizeY;
				// console.log(this.offset(draggedElem));

				let bottomCord = `${window.innerHeight - cordinates.y}px`;
				let rightCord: number | string = window.innerWidth - cordinates.x;
				if (rightCord == window.innerWidth) {
					rightCord = rightCord - 293;
				}
				rightCord = rightCord + 'px';
				// console.log(cordinates);
				// console.log('w:', window.innerWidth, 'h:', window.innerHeight);
				// console.log('r:', rightCord, 'b:', bottomCord);

				draggedElem.style.bottom = bottomCord;
				draggedElem.style.right = rightCord;

				this.setState({
					// top: sizeY,
					// left: sizeX
					bottom: bottomCord,
					right: rightCord,
				});
			}
		});
	}

	closePrompt = () => {
		this.setState({
			showPrompt: false,
		});
	};

	render() {
		return !this.props.isBotVisible ? (
			<React.Fragment>
				<div
					className='sf-bot-icon handle'
					id='sf-bot-icon'
					draggable={true}
					onDragStart={this.handleOnDragStart.bind(this)}
					onDrag={this.handleDrag.bind(this)}
				>
					{truthyOrFalsy(
						this.props.data.isLauncherPromptEnabled
							? this.props.data.isLauncherPromptEnabled ||
							  this.props.data.isLauncherPromptEnabled === 'true'
								? true
								: false
							: false
					) &&
					!this.props.data.isInsideAware &&
					!this.props.isChatStarted ? (
						<InternationalizationContext.Consumer>
							{(val) => {
								return (
									<LauncherPrompt
										showPrompt={this.state.showPrompt}
										closePrompt={this.closePrompt}
										showBot={this.props.showBot}
										langCode={
											val.currentLanguage //this.props.data.defaultLanguage || this.props.langCode
										}
										message={this.props.launcherPromptMessage}
										msgFontSize={this.props.data.fontSize}
										msgBackgroundColor={
											this.props.data.launcherPromptBackground || '#2F1C9A'
										}
										msgTextColor={
											this.props.data.launcherPromptColor || '#FFFFFF'
										}
										colorScale={this.props.data.colorScale}
										selectedColor={this.props.data.selectedColor}
										colorMode={this.props.data.colorMode}
									/>
								);
							}}
						</InternationalizationContext.Consumer>
					) : null}
					<button
						className='chatbot-button'
						onClick={() => {
							this.closePrompt();
							this.props.showBot();
						}}
					>
						{this.props.logoImagePath ==
							'https://' + window.location.hostname ||
						this.props.logoImagePath.length == 0 ? (
							<DefaultLogo />
						) : (
							<img src={this.props.logoImagePath} alt='Click To Chat' />
						)}
					</button>
				</div>
			</React.Fragment>
		) : null;
	}
}

export default Icon;
